(() => {
  if (window.cheerblePdpP1) return;
  window.cheerblePdpP1 = true;
  const quantities = new Map();
  const closingPromotions = new WeakSet();
  const titleRatingRefreshes = new WeakMap();
  let m3PromotionRoot;
  let m3PromotionObserver;
  let promotionRoot;
  let promotionObserver;
  let scheduled = false;
  let navigationFrame;
  let finishNavigation;
  const getRoot = () => document.querySelector('[data-pdp-p1]');
  function ownsNavigationTarget(root, target) {
    if (root.contains(target)) return true;
    const formId = root.dataset.p1Form;
    const rerender = root.closest('product-rerender');
    return Boolean(formId && rerender?.getAttribute('observe-form') === formId &&
      target.matches('[data-p1-fit]') && target.dataset.p1Form === formId &&
      target.closest('product-rerender') === rerender);
  }
  function stopNavigation() {
    cancelAnimationFrame(navigationFrame);
    navigationFrame = undefined;
    finishNavigation = undefined;
  }
  function focusNavigationTarget(destination) {
    const target = destination.matches('details') ? destination.querySelector('summary') : destination;
    if (!target) return;
    const temporaryTabIndex = !target.hasAttribute('tabindex') && !target.matches('a[href],button,input,select,textarea,summary,[contenteditable="true"]');
    if (temporaryTabIndex) target.setAttribute('tabindex', '-1');
    target.focus({preventScroll: true});
    if (temporaryTabIndex) target.addEventListener('blur', () => {
      if (target.getAttribute('tabindex') === '-1') target.removeAttribute('tabindex');
    }, {once: true});
  }
  function navigationOffset(destination) {
    const header = document.querySelector('.shopify-section--header') || document.querySelector('store-header');
    const headerBounds = header?.getBoundingClientRect();
    const headerHeight = headerBounds?.height || 0;
    let offset = Math.max(headerHeight, headerBounds?.bottom || 0);
    const topBar = document.querySelector('.cust-sticky-bar__list');
    const marker = topBar?.parentElement.querySelector('.top-bar-pos');
    // The product navigation fixes only after its in-flow marker. On a return
    // to P1 content above that marker it will release, so do not reserve it.
    if (topBar && marker && topBar.getClientRects().length) {
      const markerTop = marker.getBoundingClientRect().top + window.scrollY;
      if (destination.getBoundingClientRect().top + window.scrollY - offset > markerTop) {
        const bar = window.matchMedia('(max-width: 699px)').matches ? topBar : topBar.parentElement;
        offset += bar.getBoundingClientRect().height;
      }
    }
    return Math.max(0, offset) + 16;
  }
  function navigate(id, offerLink) {
    stopNavigation();
    const resolve = () => {
      const root = getRoot();
      const target = document.getElementById(id);
      if (!root || !target || (!offerLink && !ownsNavigationTarget(root, target))) return;
      return offerLink ? target.closest('.footer__block--newsletter') || target : target;
    };
    const target = resolve();
    if (!target) return;
    if (target.matches('details')) target.open = true;
    const start = window.scrollY;
    const started = performance.now();
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function step(now, finish = false) {
      // The native section can be replaced on a variant change. Resolve the
      // live ID each frame instead of keeping a detached element reference.
      const destination = resolve();
      if (!destination) return stopNavigation();
      const offset = navigationOffset(destination);
      destination.style.setProperty('--p1-anchor-offset', `${offset}px`);
      const end = Math.max(0, destination.getBoundingClientRect().top + window.scrollY - offset);
      const progress = reducedMotion || finish ? 1 : Math.min(1, (now - started) / 480);
      const eased = 1 - Math.pow(1 - progress, 3);
      // Scroll only the document. scrollIntoView also scrolls ancestors and
      // combines the theme's root scroll-padding with the old fixed margin.
      window.scrollTo({top: start + (end - start) * eased, behavior: 'instant'});
      if (progress < 1) navigationFrame = requestAnimationFrame(step);
      else {
        stopNavigation();
        focusNavigationTarget(destination);
      }
    }
    // Finish before the browser handles an early Tab, so its native next
    // focus starts at the destination rather than returning to the source.
    finishNavigation = () => {
      cancelAnimationFrame(navigationFrame);
      step(performance.now(), true);
    };
    step(started);
  }
  function syncM3PromotionLabel() {
    const root = getRoot();
    if (window.Shopify?.locale !== 'ja' || !root?.querySelector('[data-p1-summary][data-product-id="8689230250203"]')) {
      m3PromotionObserver?.disconnect();
      m3PromotionRoot = undefined;
      return;
    }
    if (m3PromotionRoot !== root) {
      m3PromotionObserver?.disconnect();
      m3PromotionRoot = root;
      m3PromotionObserver = new MutationObserver(syncM3PromotionLabel);
      m3PromotionObserver.observe(root, {childList: true, subtree: true, characterData: true});
    }
    // BOGOS owns discount rules and prices. Its canonical tier, not the stale
    // translated label, supplies the quantity and percentage for this badge.
    const allBundles = window.FGSECOMAPP?.bundles;
    if (!Array.isArray(allBundles)) return;
    const bundles = allBundles.filter(bundle => bundle && typeof bundle === 'object' && String(bundle.id) === '31753' && bundle.type === 'mix_match');
    if (bundles.length !== 1 || !Array.isArray(bundles[0].discount)) return;
    const tiers = bundles[0].discount.filter(tier => tier && typeof tier === 'object' && String(tier.id) === '1');
    if (tiers.length !== 1) return;
    const {quantity, discount} = tiers[0];
    if (!Number.isSafeInteger(quantity) || quantity < 1 || discount?.type !== 'percentage' ||
        !Number.isFinite(discount.value) || discount.value <= 0 || discount.value >= 100) return;
    const percent = new Intl.NumberFormat('ja-JP', {maximumFractionDigits: 20}).format(discount.value);
    const text = `${quantity}点お買い上げでさらに${percent}% OFF`;
    root.querySelectorAll('.bogos-mix-match-widget[data-mix-match-id="31753"]').forEach(widget => {
      const labels = widget.querySelectorAll('.bogos-mix-match-badge-item[data-discount-id="1"] .bogos-mix-match-badge-title');
      if (labels.length === 1 && labels[0].textContent.trim() !== text) labels[0].textContent = text;
    });
  }
  function managePromotion() {
    if (!getRoot() || !window.matchMedia('(max-width: 699px)').matches) return;
    const wrapper = document.getElementById('omnisend-forms-wrapper');
    if (!wrapper) return;
    if (promotionRoot !== wrapper) {
      promotionObserver?.disconnect();
      promotionRoot = wrapper;
      promotionObserver = new MutationObserver(managePromotion);
      promotionObserver.observe(wrapper, {childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'aria-hidden', 'aria-modal']});
    }
    wrapper.querySelectorAll('[role="dialog"][aria-modal="true"]').forEach(dialog => {
      if (getComputedStyle(dialog).display === 'none') {
        closingPromotions.delete(dialog);
        return;
      }
      const close = dialog.querySelector('button[id^="omnisend-form-"][id$="-close-action"]');
      if (close && !closingPromotions.has(dialog)) {
        closingPromotions.add(dialog);
        close.click();
      }
    });
  }
  const mainQuantity = root => document.querySelector(`input[name="quantity"][form="${CSS.escape(root.dataset.p1Form)}"]`) || document.getElementById(root.dataset.p1Form)?.elements.namedItem('quantity');
  function quantity(root) {
    const input = mainQuantity(root);
    if (!input) return 1;
    const minimum = Number(input.min) || 1;
    const maximum = input.max ? Number(input.max) : Infinity;
    return Math.max(minimum, Math.min(maximum, Math.floor(Number(input.value) || minimum)));
  }
  function update() {
    scheduled = false;
    const root = getRoot();
    if (!root) return;
    document.documentElement.classList.add('p1-active');
    document.querySelectorAll('king-linked-options-product[data-render-context="product-page"],#king-linked-options-section').forEach(node => node.remove());
    const form = document.getElementById(root.dataset.p1Form);
    const sticky = document.querySelector('[data-p1-sticky]');
    if (!form || !sticky) return;
    const q = quantity(root);
    quantities.set(root.dataset.p1Form, q);
    const quantityText = sticky.querySelector('[data-p1-quantity]');
    if (!quantityText.dataset.label) quantityText.dataset.label = quantityText.textContent.replace(/\s+1\s*$/, '');
    quantityText.textContent = `${quantityText.dataset.label} ${q}`;
    const total = sticky.querySelector('[data-p1-total]');
    try {
      total.textContent = new Intl.NumberFormat(sticky.dataset.locale, {style: 'currency', currency: sticky.dataset.currency, currencyDisplay: 'code'}).format(Number(sticky.dataset.unitPrice) * q / 100);
    } catch (_) {
      total.textContent = `${sticky.dataset.currency} ${(Number(sticky.dataset.unitPrice) * q / 100).toFixed(2)}`;
    }
    const button = form.querySelector('button[type="submit"]');
    const footer = document.querySelector('.footer');
    const show = button && button.getBoundingClientRect().bottom <= 0 && (!footer || footer.getBoundingClientRect().top > window.innerHeight);
    sticky.classList.toggle('is-visible', Boolean(show));
    sticky.inert = !show;
  }
  function schedule() {
    if (!scheduled) {scheduled = true; requestAnimationFrame(update);}
  }
  function restore() {
    const root = getRoot();
    syncM3PromotionLabel();
    if (!root) return;
    managePromotion();
    const remembered = quantities.get(root.dataset.p1Form);
    const input = mainQuantity(root);
    if (input && remembered) {
      input.value = String(remembered);
      input.value = String(quantity(root));
    }
    schedule();
  }
  function refreshTitleRating(root) {
    if (titleRatingRefreshes.has(root)) return;
    const formId = root.dataset.p1Form;
    const form = formId && document.getElementById(formId);
    const renderer = root.closest('product-rerender');
    const badge = root.querySelector('.p1-title-rating[data-id]');
    if (!form || !renderer?.id || renderer.getAttribute('observe-form') !== formId || !badge || badge.querySelector('.stamped-badge')) return;
    const rendererId = renderer.id;
    const delays = [1500, 3000];
    let checks = 0;
    let timer;
    const valid = () => root.isConnected && getRoot() === root && root.dataset.p1Form === formId &&
      document.getElementById(formId) === form && document.getElementById(rendererId) === renderer &&
      renderer.getAttribute('observe-form') === formId && root.closest('product-rerender') === renderer && root.contains(badge);
    const stop = () => {
      clearTimeout(timer);
      observer.disconnect();
      if (titleRatingRefreshes.get(root) === stop) titleRatingRefreshes.delete(root);
    };
    const observer = new MutationObserver(() => {
      if (!valid() || badge.querySelector('.stamped-badge')) stop();
    });
    const check = () => {
      if (!valid() || badge.querySelector('.stamped-badge')) return stop();
      try {
        if (typeof window.StampedFn?.loadBadges === 'function') window.StampedFn.loadBadges();
      } catch (_) {}
      if (badge.querySelector('.stamped-badge')) return stop();
      if (checks < delays.length) timer = setTimeout(check, delays[checks++]);
      else stop();
    };
    titleRatingRefreshes.set(root, stop);
    observer.observe(badge, {childList: true, subtree: true});
    check();
  }
  document.addEventListener('input', event => {
    const root = getRoot();
    if (!root || event.target !== mainQuantity(root)) return;
    quantities.set(root.dataset.p1Form, quantity(root));
    schedule();
  }, true);
  document.addEventListener('change', event => {
    const root = getRoot();
    if (root && event.target === mainQuantity(root)) quantities.set(root.dataset.p1Form, quantity(root));
    schedule();
  }, true);
  document.addEventListener('product:rerender', event => {
    const root = getRoot();
    if (root) quantities.set(root.dataset.p1Form, quantity(root));
    const rerender = root?.closest('product-rerender');
    const formId = root?.dataset.p1Form;
    const ownsForm = formId && event.target === document.getElementById(formId) && !event.detail?.productChange;
    const focused = document.activeElement;
    const focusedId = ownsForm && rerender?.contains(focused) ? focused.id : '';
    queueMicrotask(() => {
      restore();
      if (root && !root.isConnected) titleRatingRefreshes.get(root)?.();
      if (!ownsForm || !rerender?.id) return;
      const current = document.getElementById(rerender.id);
      if (!current || current === rerender) return;
      const currentRoot = current.querySelector('[data-pdp-p1]');
      if (currentRoot?.dataset.p1Form !== formId) return;
      if (focusedId && !focused.isConnected && document.activeElement === document.body) {
        const replacement = document.getElementById(focusedId);
        if (current.contains(replacement) && !replacement.matches(':disabled') && replacement.getClientRects().length) {
          replacement.focus({preventScroll: true});
        }
      }
      refreshTitleRating(currentRoot);
    });
  }, true);
  document.addEventListener('variant:change', schedule, true);
  document.addEventListener('cart:change', schedule);
  document.addEventListener('shopify:section:load', restore);
  document.addEventListener('click', event => {
    const anchor = event.target.closest?.('a[href^="#p1-help-"],a[href^="#p1-fit-"],a[href^="#p1-support-"],a[data-p1-offer-link],a[href^="#p1-models-"]');
    const root = getRoot();
    if (!anchor || !root?.contains(anchor) || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const target = document.getElementById(anchor.hash.slice(1));
    const offerLink = anchor.hasAttribute('data-p1-offer-link');
    if (!target || (!offerLink && !ownsNavigationTarget(root, target))) return;
    event.preventDefault();
    event.stopPropagation();
    // Keep the hash unchanged: neither browser fragment navigation nor the
    // theme's generic anchor delegate should schedule a second scroll.
    navigate(target.id, offerLink);
  }, true);
  // A later interaction cancels both animation and its pending focus move.
  document.addEventListener('pointerdown', stopNavigation, true);
  document.addEventListener('focusin', stopNavigation);
  window.addEventListener('wheel', stopNavigation, {passive: true});
  window.addEventListener('touchstart', stopNavigation, {passive: true});
  document.addEventListener('keydown', event => {
    if (event.key === 'Tab') finishNavigation?.();
    if (['ArrowUp', 'ArrowDown', 'PageUp', 'PageDown', 'Home', 'End', 'Escape'].includes(event.key)) stopNavigation();
  });
  const observer = new MutationObserver(records => {
    const relevant = records.some(record => [...record.addedNodes].some(node => node.nodeType === 1 && (node.matches('product-rerender,[data-pdp-p1],[data-p1-sticky],king-linked-options-product,#omnisend-forms-wrapper') || node.querySelector('[data-pdp-p1],[data-p1-sticky],king-linked-options-product,#omnisend-forms-wrapper'))));
    if (relevant || (m3PromotionRoot && !m3PromotionRoot.isConnected)) restore();
  });
  observer.observe(document.body, {childList: true, subtree: true});
  window.addEventListener('scroll', schedule, {passive: true});
  window.addEventListener('resize', () => {schedule(); managePromotion();});
  restore();
})();

// Optional gallery owns only measurement and its thumbnail rail. Native media selection stays native.
(() => {
  if (customElements.get('p1-aligned-gallery')) return;
  class P1AlignedGallery extends HTMLElement {
    connectedCallback() {
      this._connection = new AbortController();
      this._desktop = matchMedia('(min-width: 1000px)');
      this._reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this._desktop.addEventListener('change', () => this._setDesktop(), {signal: this._connection.signal});
      this._setDesktop();
    }
    disconnectedCallback() {
      this._connection?.abort();
      this._stopDesktop();
    }
    _setDesktop() {
      this._stopDesktop();
      if (!this._desktop.matches) return;
      const product = this.closest('[data-p1-aligned-product]');
      this._info = product?.querySelector(':scope > .product-info[data-pdp-p1]');
      this._inner = this.querySelector('.p1-gallery-sticky');
      this._track = this.querySelector('[data-p1-thumbnail-track]');
      this._rail = this.querySelector('[data-p1-gallery-rail]');
      this._header = document.querySelector('.shopify-section--header') || document.querySelector('store-header');
      if (!this._info || !this._inner) return;
      this._session = new AbortController();
      this._imageSizes = new Map();
      const signal = this._session.signal;
      const schedule = () => {
        if (!this._frame) this._frame = requestAnimationFrame(() => {this._frame = undefined; if (this.isConnected && this._session) this._measure();});
      };
      this._resize = new ResizeObserver(schedule);
      [this._inner, this._info, this._track, this._header].filter(Boolean).forEach(node => this._resize.observe(node));
      this._mutations = new MutationObserver(schedule);
      this._mutations.observe(this._inner, {childList: true, subtree: true, attributes: true, attributeFilter: ['hidden','aria-current']});
      this.addEventListener('load', schedule, {capture: true, signal});
      this.addEventListener('carousel:change', schedule, {signal});
      this.addEventListener('carousel:settle', schedule, {signal});
      this._info.addEventListener('toggle', schedule, {capture: true, signal});
      window.addEventListener('resize', schedule, {passive: true, signal});
      this._track?.addEventListener('scroll', () => this._updateRail(), {passive: true, signal});
      this._rail?.addEventListener('click', event => {
        const button = event.target.closest('[data-p1-rail-prev],[data-p1-rail-next]');
        if (!button || button.disabled || !this._track) return;
        const direction = button.hasAttribute('data-p1-rail-prev') ? -1 : 1;
        const rtl = getComputedStyle(this._track).direction === 'rtl' ? -1 : 1;
        this._track.scrollBy({left: direction * rtl * Math.max(92, this._track.clientWidth - 92), behavior: this._reduced.matches ? 'auto' : 'smooth'});
      }, {signal});
      // PageDots already selects the native carousel and scrolls only its own track.
      // The native media API accepts animate:false; use that existing path for reduced motion.
      this.addEventListener('control:select', event => {
        if (!this._reduced.matches || !event.target.matches('media-carousel')) return;
        event.stopImmediatePropagation();
        event.target.select(event.detail.index, {animate: false});
      }, {capture: true, signal});
      this._barHost = this.closest('.shopify-section');
      this._barMutations = new MutationObserver(schedule);
      this._schedule = schedule;
      this._bindPurchaseBar();
      this._barTree = new MutationObserver(records => {
        const changed = records.some(record => [...record.addedNodes, ...record.removedNodes].some(node =>
          node.nodeType === 1 && (node.matches('[data-p1-sticky]') || node.querySelector('[data-p1-sticky]'))));
        if (changed) {this._bindPurchaseBar();schedule();}
      });
      if (this._barHost) this._barTree.observe(this._barHost, {childList: true, subtree: true});
      schedule();
    }
    _bindPurchaseBar() {
      const bar = [...(this._barHost?.querySelectorAll('[data-p1-sticky]') || [])].find(node =>
        node.getAttribute('form') === this.getAttribute('data-p1-gallery-form'));
      if (bar === this._purchaseBar) return;
      if (this._purchaseBar) this._resize.unobserve(this._purchaseBar);
      this._barBinding?.abort();
      this._barMutations.disconnect();
      this._purchaseBar = bar;
      if (!bar) return;
      this._barBinding = new AbortController();
      this._resize.observe(bar);
      this._barMutations.observe(bar, {attributes: true, attributeFilter: ['class','style','hidden']});
      bar.addEventListener('transitionend', this._schedule, {signal: this._barBinding.signal});
      bar.addEventListener('transitioncancel', this._schedule, {signal: this._barBinding.signal});
    }
    _bottomObstruction() {
      const bar = this._purchaseBar;
      if (!bar || bar.hidden) return 0;
      const style = getComputedStyle(bar);
      // Reserve the full fixed box as soon as the native state turns on, and
      // until its existing fade-out ends. Transformed animation bounds alone
      // would otherwise undercount the entering bar or release it too early.
      const visible = bar.classList.contains('is-visible') ||
        (style.visibility === 'visible' && parseFloat(style.opacity) > 0);
      if (!visible || style.display === 'none' || style.position !== 'fixed') return 0;
      return Math.max(0, bar.getBoundingClientRect().height + (parseFloat(style.bottom) || 0));
    }
    _measure() {
      const gallery = this._inner.getBoundingClientRect();
      const info = this._info.getBoundingClientRect();
      const last = [...this._info.children].reverse().find(node => node.getBoundingClientRect().height > 0);
      const tail = Math.max(0, info.bottom - (last?.getBoundingClientRect().bottom ?? info.bottom));
      const headerHeight = this._header?.getBoundingClientRect().height || 0;
      // A negative top lets a tall gallery scroll naturally until its bottom is visible.
      // CSS sticky then stops at this stretched column's content boundary, before fit.
      const top = Math.min(headerHeight + 16, window.innerHeight - this._bottomObstruction() - gallery.height - 16);
      const canStick = info.height - tail >= gallery.height && gallery.height > 0;
      this.toggleAttribute('data-p1-sticky-ready', canStick);
      this.style.setProperty('--p1-gallery-top', `${top}px`);
      this.style.setProperty('--p1-gallery-tail', `${canStick ? tail : 0}px`);
      const width = Math.ceil(gallery.width);
      if (width > 0) {
        this._inner.querySelectorAll('.product-gallery__media > img, .product-gallery__media > video-media > img').forEach(image => {
          if (!this._imageSizes.has(image)) this._imageSizes.set(image, image.getAttribute('sizes'));
          // Actual slot width also handles editor gutter/page-width changes without guessing42vw.
          if (image.getAttribute('sizes') !== `${width}px`) image.setAttribute('sizes', `${width}px`);
        });
      }
      this._updateRail();
      this._alignCurrentOnTrackResize();
    }
    _alignCurrentOnTrackResize() {
      if (!this._track) return;
      const width = this._track.clientWidth;
      if (width <= 0 || width === this._lastTrackWidth || typeof this._track.select !== 'function') return;
      const index = this._track.selectedIndex;
      const current = this._track.children[index];
      if (!current || current.hidden) return;
      this._lastTrackWidth = width;
      const track = this._track.getBoundingClientRect();
      const item = current.getBoundingClientRect();
      const left = track.left + this._track.clientLeft;
      // Reuse native PageDots alignment without dispatching media selection.
      // Ordinary rail scrolling or a height-only measure never resets browsing.
      if (item.left < left - 1 || item.right > left + width + 1) this._track.select(index, false);
    }
    _updateRail() {
      if (!this._track || !this._rail) return;
      const visible = [...this._track.children].filter(button => !button.hidden);
      this._rail.hidden = visible.length < 2;
      const extent = Math.max(0, this._track.scrollWidth - this._track.clientWidth);
      const rtl = getComputedStyle(this._track).direction === 'rtl';
      const position = Math.max(0, Math.min(extent, rtl ? -this._track.scrollLeft : this._track.scrollLeft));
      this._rail.toggleAttribute('data-p1-no-overflow', extent <= 1);
      this._rail.querySelector('[data-p1-rail-prev]').disabled = position <= 1;
      this._rail.querySelector('[data-p1-rail-next]').disabled = position >= extent - 1;
    }
    _stopDesktop() {
      this._session?.abort();
      this._session = undefined;
      this._resize?.disconnect();
      this._mutations?.disconnect();
      this._barMutations?.disconnect();
      this._barTree?.disconnect();
      this._barBinding?.abort();
      this._purchaseBar = undefined;
      this._lastTrackWidth = undefined;
      this._schedule = undefined;
      cancelAnimationFrame(this._frame);
      this._frame = undefined;
      this.removeAttribute('data-p1-sticky-ready');
      this.style.removeProperty('--p1-gallery-top');
      this.style.removeProperty('--p1-gallery-tail');
      this._imageSizes?.forEach((sizes,image) => sizes === null ? image.removeAttribute('sizes') : image.setAttribute('sizes',sizes));
      this._imageSizes?.clear();
      if (this._rail) {this._rail.hidden = false;this._rail.removeAttribute('data-p1-no-overflow');}
    }
  }
  customElements.define('p1-aligned-gallery', P1AlignedGallery);
})();
